import { registerComponent } from '@gig/magic-common';
import FaqCategoriesComponent from './faq-categories.vue.js';

var FaqCategories = registerComponent(FaqCategoriesComponent);

export { FaqCategories };
